module.exports = __webpack_public_path__ + "static/main-60670e76cec8b04ffe7a029f4f9e4f7d.jpg";